import React from 'react';
import { useNavigate } from 'react-router-dom';

const AuthError = () => {
  const navigate = useNavigate();

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-error">
          <h2>Authentication Failed</h2>
          <p>There was a problem signing you in. Please try again.</p>
          <button 
            onClick={() => navigate('/login')} 
            className="btn btn-primary"
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthError;